import React from "react";
import { Package } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-white border-t border-slate-200 text-slate-600 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="space-y-2 text-center md:text-left">
            <Link to="/" className="inline-flex items-center justify-center md:justify-start gap-2.5">
              <div className="p-2 rounded-xl bg-amber-100 text-amber-800 border border-amber-200">
                <Package className="h-5 w-5" />
              </div>
              <span className="text-lg font-extrabold text-slate-900 tracking-tight">
                Export <span className="text-amber-600">Stuff</span>
              </span>
            </Link>
            <p className="text-xs text-slate-500 max-w-sm">
              Simplifying global trade documentation, Incoterm pricing, and export tile inventory management worldwide.
            </p>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-6 text-xs font-bold text-slate-700">
            <Link to="/" className="hover:text-amber-700 transition-colors">Home</Link>
            <Link to="/login" className="hover:text-amber-700 transition-colors">Sign In</Link>
            <Link to="/signup" className="hover:text-amber-700 transition-colors">Register</Link>
            <Link to="/privacy" className="hover:text-amber-700 transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-amber-700 transition-colors">Terms of Service</Link>
            <a href="/#pricing" className="hover:text-amber-700 transition-colors">Pricing</a>
            <a href="/#faq" className="hover:text-amber-700 transition-colors">FAQ</a>
            <a href="/#contact" className="hover:text-amber-700 transition-colors">Support</a>
          </div>

          <div className="text-center md:text-right space-y-1">
            <p className="text-xs text-slate-500">
              © {new Date().getFullYear()} Export Stuff Inc. All rights reserved.
            </p>
            <p className="text-[11px] text-amber-700 font-bold">
              Trusted by 100+ ceramics manufacturers and global trade exporters
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

